module.exports = __webpack_public_path__ + "img/d67af12.png";